<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="card-header__name">
          <h3 v-if="mData.viewMode === 'create'">THÊM MỚI PHIẾU THANH TOÁN</h3>
          <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT PHIẾU THANH TOÁN</h3>
        </div>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-position="left"
          label-width="130px"
          class="form-phieu-thanh-toan"
        >
          <div v-if="mData.viewMode === 'detail'">
            <el-row :gutter="10">
              <el-col :md="8">
                <div class="form-item">
                  <span class="title">Đại lý:</span>
                  <router-link
                    :to="`/admin/dai-ly/chi-tiet/${mData.dataForm.dai_ly_id}`"
                  >
                    {{ fn_getTenDaiLy(mData.dataForm.dai_ly_id) }}
                  </router-link>
                </div>
              </el-col>
              <el-col :md="8">
                <div class="form-item">
                  <span class="title">Kỳ thanh toán:</span>
                  <span>{{
                    `Tháng ${mData.dataForm.ky_thanh_toan.thang}/${mData.dataForm.ky_thanh_toan.nam}`
                  }}</span>
                </div>
              </el-col>
              <el-col :md="8">
                <div class="form-item">
                  <span class="title">Thời điểm tạo:</span>
                  <span>{{ fn_formatDate(mData.dataForm.thoi_diem_tao) }}</span>
                </div>
              </el-col>
            </el-row>
            <div class="form-item" v-if="mData.dataForm.noi_dung">
              <span class="title">Nội dung:</span>
              <span style="white-space: break-spaces;">{{ mData.dataForm.noi_dung }}</span>
            </div>
            <div
              class="form-item paperclip"
              v-if="mData.listBienLaiIDs.length > 0"
            >
              <span @click="dialogBienLai = !dialogBienLai"
                ><i class="fa-regular fa-paperclip"></i> Xem biên lai, hóa đơn
                thanh toán</span
              >
            </div>
            <el-table
              :data="mData.tableDataPhieuThanhToan"
              style="width: 100%"
              max-height="540"
              header-cell-class-name="vt-header-table"
              class="table-box-shadow mt-3"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Mã đơn hàng"
                align="center"
                min-width="180"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="`/admin/don-hang/danh-sach-don-hang/chi-tiet/${scope.row.don_hang_id}}`"
                    target="_blank"
                  >
                    {{ scope.row.ma_don_hang }}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="tong_tien"
                label="Tổng tiền"
                width="180"
                align="center"
              />
              <el-table-column
                prop="tien_tra_cho_viet_toc"
                label="Tiền trả cho đại lý"
                width="150"
                align="right"
              />
            </el-table>
            <div class="form-phieu-thanh-toan__tong-tien">
              <span>Tổng tiền</span>
              <span>{{ mData.dataForm.so_tien }}</span>
            </div>
          </div>
          <div v-if="mData.viewMode !== 'detail'">
            <b-row>
              <b-col :md="4">
                <el-form-item label="Đại lý" prop="dai_ly_id">
                  <el-select
                    v-model="mData.dataForm.dai_ly_id"
                    placeholder="Chọn đại lý"
                    @change="fn_getDaiLyId"
                    ref="dai_ly_id"
                    filterable
                  >
                    <el-option
                      v-for="item in mData.listDaiLy"
                      :key="item.id"
                      :label="item.ten"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col :md="4">
                <el-form-item label="Kỳ thanh toán" prop="ky_thanh_toan_str">
                  <el-date-picker
                    ref="ky_thanh_toan_str"
                    v-model="mData.dataForm.ky_thanh_toan_str"
                    type="month"
                    format="MM-yyyy"
                    placeholder="Chọn kỳ thanh toán"
                  >
                  </el-date-picker>
                </el-form-item>
              </b-col>
            </b-row>
            <el-form-item label="Nội dung" class="form-item__noidung">
              <el-input
                v-model="mData.dataForm.noi_dung"
                placeholder="Nhập nội dung"
                type="textarea"
                :rows="2"
              >
              </el-input>
            </el-form-item>
            <div class="form-item paperclip">
              <span @click="dialogUploadFile = !dialogUploadFile"
                ><i class="fa-regular fa-cloud-arrow-up"></i> Tải lên biên lai,
                hóa đơn thanh toán</span
              >
              <div
                class="form-phieu-thanh-toan__list-files"
                v-if="mData.listBienLaiName.length > 0"
              >
                <div
                  class="form-phieu-thanh-toan__file-item"
                  v-for="(item, index) in mData.listBienLaiName"
                  :key="item.id"
                >
                  <p :title="item">{{ item }}</p>
                  <span title="Xóa" @click="fn_deletePhieuThanhToan(index)"
                    ><i class="fa-solid fa-circle-xmark"></i
                  ></span>
                </div>
              </div>
            </div>

            <el-table
              v-if="mData.dataForm.dai_ly_id"
              v-loading="loadingTableDataPhieuThanhToanCreate"
              :data="mData.tableDataPhieuThanhToanCreate"
              style="width: 100%"
              max-height="500"
              border
              header-cell-class-name="vt-header-table"
              class="table-box-shadow mt-3"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="47" align="center">
              </el-table-column>
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Mã đơn hàng"
                align="center"
                min-width="180"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="`/admin/don-hang/danh-sach-don-hang/chi-tiet/${scope.row.id}`"
                    target="_blank"
                  >
                    {{ scope.row.ma_don_hang }}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="tong_tien"
                label="Tổng tiền"
                width="180"
                align="center"
              >
                <template slot-scope="scope">{{
                  fn_formatCurrencyVND(scope.row.tong_tien)
                }}</template>
              </el-table-column>
              <el-table-column
                prop="tien_tra_cho_dai_ly"
                label="Tiền trả cho đại lý"
                width="150"
                align="right"
              >
                <template slot-scope="scope">{{
                  fn_formatCurrencyVND(scope.row.tien_tra_cho_dai_ly)
                }}</template>
              </el-table-column>
            </el-table>
          </div>

          <FileView
            v-if="dialogBienLai"
            :ids="mData.listBienLaiIDs"
            :typeFile="'biên lai'"
            :typeView="typeView"
            @close-dialog="dialogBienLai = false"
            @show-add-files="dialogUploadFile = true"
            :key="mData.reRenderFileViewBienLaiFile"
          ></FileView>
          <UploadFile
            v-if="dialogUploadFile"
            :typeFile="'biên lai'"
            :srcString="'pmt_dai_ly'"
            :fieldString="'file_dinh_kem'"
            :ownerIdString="mData.daiLyId"
            @close-dialog="dialogUploadFile = false"
            @list-files-ids="fn_getListBienLai"
            @accept-list-files="fn_acceptListFiles"
          ></UploadFile>
          <div class="text-center mt-3">
            <el-button type="default" @click="fn_back()" v-ladda
              >quay lại</el-button
            >
            <el-button
              type="primary"
              @click="fn_addPhieuThanhToan('create')"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "@/service/ValidService";
import MethodService from "@/service/MethodService";
import LanguageService from "@/service/LanguageService";
import DataForm from "@/dataForm/dataFormPhieuThanhToan";
import { Circle4 } from "vue-loading-spinner";
import FileView from "@/component/FileView.vue";
import UploadFile from "@/component/UploadFiles.vue";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    Circle4,
    FileView,
    UploadFile,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      dialogBienLai: false,
      dialogUploadFile: false,
      loadingTableDataPhieuThanhToanCreate: false,
      typeView: "detail",
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        listDaiLy: [],
        daiLyId: "",
        listBienLaiIDs: [],
        listBienLaiName: [],
        validForm: {
          dai_ly_id: [ValidService.requiredChange],
          ky_thanh_toan_str: [ValidService.requiredChange],
        },
        nameDaiLy: null,
        reRenderFileViewBienLaiFile: 0,
        tableDataPhieuThanhToan: [],
        tableDataPhieuThanhToanCreate: [],
        ky_thanh_toan: "",
        danh_sach_don_hang_create: [],
        cauHinhHeThong: {
          gia_tri: 0,
        },
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.mData.dataForm.so_tien = 0;
      if (val.length == 0) {
        this.mData.danh_sach_don_hang_create = [];
        return;
      }
      val.forEach(
        (e) => (this.mData.dataForm.so_tien += e.tien_tra_cho_dai_ly)
      );
      this.mData.danh_sach_don_hang_create = val.map((x) => {
        return {
          don_hang_id: x.id,
          ma_don_hang: x.ma_don_hang,
        };
      });
    },
    fn_formatCurrencyVND(value) {
      return MethodService.formatCurrencyVND(value);
    },
    async fn_initForm() {
      try {
        const response = await mushroom.pmt_dai_ly.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields: this.mData.tableRules.fields,
        });
        if (response.result) {
          this.mData.listBienLaiIDs = response.result.file_dinh_kem || [];
          const res = await this.fn_changeData(response.result);
          this.mData.dataForm = res;
          this.mData.daiLyId = res.dai_ly_id;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      } finally {
        this.loading = false;
      }
    },
    async fn_changeData(data) {
      data.so_tien = MethodService.formatCurrencyVND(data.so_tien);
      if (data.danh_sach_don_hang) {
        const listIdDonHang = data.danh_sach_don_hang.map((x) => x.don_hang_id);
        const res_ord_don_hang = await mushroom.ord_don_hang.listAsync({
          filters: ["id:in:" + listIdDonHang],
        });
        if (res_ord_don_hang.result && res_ord_don_hang.result.length > 0) {
          res_ord_don_hang.result.forEach((item) => {
            item.tien_tra_cho_viet_toc = 0;
            if (item.danh_sach_san_pham) {
              item.danh_sach_san_pham.forEach((x) => {
                x.tien_tra_cho_viet_toc = 0;
                if (x.chiet_khau_dai_ly) {
                  item.tien_tra_cho_viet_toc += x.chiet_khau_dai_ly;
                }
              });
            }
            data.danh_sach_don_hang.forEach((x) => {
              if (item.ma_don_hang === x.ma_don_hang) {
                x.thoi_diem_tao = this.fn_formatDate(item.thoi_diem_tao);
                x.tong_tien = MethodService.formatCurrencyVND(item.tong_tien);
                x.tien_tra_cho_viet_toc = MethodService.formatCurrencyVND(
                  item.tien_tra_cho_viet_toc
                );
              }
            });
          });
          this.mData.tableDataPhieuThanhToan = data.danh_sach_don_hang;
        }
      }

      return data;
    },
    async fn_getDaiLy() {
      const response = await mushroom.agt_dai_ly.getAllAsync({
        filters: ["loai_dong_tien=ve_viettoc"],
        fields: "id,ten",
      });
      const cauHinhHeThongRes = await mushroom.cau_hinh_he_thong.listAsync({
        filters: `ten=agt_so_ngay_hoan_tra`,
        fields: "id,ghi_chu,gia_tri",
      });
      if (cauHinhHeThongRes.result) {
        this.mData.cauHinhHeThong = cauHinhHeThongRes.result[0];
        console.log("this.mData.cauHinhHeThong", this.mData.cauHinhHeThong);
      }
      if (response.result && response.result.length > 0) {
        this.mData.listDaiLy = response.result;
      }
    },
    fn_getDaiLyId(id) {
      if (!id) return;
      this.getPmtDaiLy(id);
      this.mData.daiLyId = id;
    },
    async getPmtDaiLy(daiLyId) {
      try {
        const response = await mushroom.pmt_dai_ly.getAllAsync({
          filters: `dai_ly_id=${daiLyId}`,
          fields: "id,dai_ly_id,danh_sach_don_hang",
        });
        const arrDonDangIds = [];
        response.result.forEach((e) => {
          if (!e.danh_sach_don_hang) return;
          e.danh_sach_don_hang.forEach((x) => {
            arrDonDangIds.push(x.don_hang_id);
          });
        });
        this.getOrderByDaiLy(_.uniq(arrDonDangIds));
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async getOrderByDaiLy(arrDonHangExists) {
      try {
        this.loadingTableDataPhieuThanhToanCreate = true
        const res = await mushroom.ord_don_hang.getAllAsync({
          filters: `id:nin:${arrDonHangExists.join(",")}&dai_ly_id=${
            this.mData.daiLyId
          }&trang_thai_thanh_toan=da_thanh_toan&trang_thai=hoan_thanh&lich_su:elemMatch:trang_thai=da_thanh_toan,thoi_diem<=$$now-${
            this.mData.cauHinhHeThong.gia_tri
          }days`,
          fields:
            "dai_ly_id,tong_tien,ma_don_hang,loai_don_hang,danh_sach_san_pham",
        });
        res.result.forEach((e) => {
          e.tien_tra_cho_dai_ly = 0;
          if (!e.danh_sach_san_pham) return;
          e.danh_sach_san_pham.forEach((x) => {
            e.tien_tra_cho_dai_ly += x.chiet_khau_dai_ly;
          });
        });
        this.mData.tableDataPhieuThanhToanCreate = res.result.filter(x => x.tien_tra_cho_dai_ly !== 0)
        setTimeout(() => {
          this.loadingTableDataPhieuThanhToanCreate = false
        }, 500);
      } catch (error) {
        console.log("error", error);
        this.loadingTableDataPhieuThanhToanCreate = false
      }
    },
    fn_getTenDaiLy(idAgent) {
      const daiLy = this.mData.listDaiLy.find((x) => x.id === idAgent);
      return daiLy && daiLy.ten ? daiLy.ten : "Chưa có thông tin";
    },
    fn_formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    fn_getListBienLai(ids) {
      if (ids && ids.length > 0)
        ids.forEach((idFile) => this.mData.listBienLaiIDs.push(idFile));
    },
    fn_acceptListFiles(nameFiles) {
      if (nameFiles && nameFiles.length > 0)
        nameFiles.forEach((file) => this.mData.listBienLaiName.push(file));
      this.dialogUploadFile = false;
    },
    fn_deletePhieuThanhToan(index) {
      this.mData.listBienLaiName.splice(index, 1);
      this.mData.listBienLaiIDs.splice(index, 1);
    },
    fn_addPhieuThanhToan() {
      this.$refs["myForm"].validate(async (valid, objectError) => {
        if (valid) {
          if (this.mData.danh_sach_don_hang_create.length === 0) {
            window.toastr.warning(
              "Vui lòng chọn đơn hàng để tạo phiếu thanh toán!"
            );
            MethodService.stopLadda();
            return;
          }
          this.mData.dataForm.ben_thanh_toan = "viettoc";
          this.mData.dataForm.file_dinh_kem = this.mData.listBienLaiIDs;
          const ky_thanh_toan_value = new Date(
            this.mData.dataForm.ky_thanh_toan_str
          );
          this.mData.dataForm.ky_thanh_toan.thang =
            ky_thanh_toan_value.getMonth() + 1;
          this.mData.dataForm.ky_thanh_toan.nam =
            ky_thanh_toan_value.getFullYear();
          this.mData.dataForm.danh_sach_don_hang =
            this.mData.danh_sach_don_hang_create;
          MethodService.stopLadda();
          try {
            await mushroom.pmt_dai_ly.createAsync(this.mData.dataForm);
            window.toastr.success("Thêm mới phiếu thanh toán thành công");
            this.fn_back();
          } catch (error) {
            console.error("Có lỗi: %o", error);
            window.toastr.error("Thêm mới phiếu thanh toán thất bại");
          }
        } else {
          MethodService.stopLadda();
          let arrKey = Object.keys(objectError);
          if (arrKey.length > 0) {
            this.$refs[arrKey[0]].$el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            setTimeout(() => {
              this.$refs[arrKey[0]].focus();
            }, 500);
          }
          return false;
        }
      });
    },
    fn_back() {
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    await this.fn_getDaiLy();
    if (this.$router.currentRoute.name == "ThemMoiPhieuThanhToan") {
      this.mData.viewMode = "create";
      this.typeView = "create";
      this.loading = false;
    } else {
      this.mData.viewMode = "detail";
      this.typeView = "detail";
      await this.fn_initForm();
    }
  },
};
</script>
<style scoped lang="scss">
::v-deep.form-phieu-thanh-toan {
  &__tong-tien {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    span:last-child {
      color: green;
      font-size: 18px;
    }
  }
  &__list-files {
    display: flex;
    flex-wrap: wrap;
  }
  &__file-item {
    padding: 5px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    background-color: #ecf5ff;
    border: thin solid #b3d8ff;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: default;
    width: 120px;
    p {
      display: block;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
    }
    span i {
      color: #f56c6c;
      cursor: pointer;
    }
  }
}
::v-deep.form-item {
  padding-bottom: 10px;
  .title {
    font-weight: 600;
    margin-right: 6px;
  }
}
.paperclip > span {
  color: #409eff;
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    color: #0080ff;
  }
}
::v-deep .el-table {
  .el-table__header {
    .el-table__cell {
      .cell {
        .el-checkbox {
          margin-bottom: 0;
          margin-top: 1.8px;
        }
      }
    }
  }
  .el-table__body {
    .el-table__cell {
      .cell {
        .el-checkbox {
          margin-bottom: 0;
          margin-left: 4px;
          margin-top: 1.5px;
        }
      }
    }
  }
}
</style>
